export class LoginService {
    authenticationToken: string = null;
    login: string = null;
}

export const loginService = new LoginService();
